import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";

export default function SubscriptionCancel() {
  const { t } = useLang();
  return (
    <div className="mx-auto flex max-w-md flex-col items-center pt-10 text-center" data-testid="subscription-cancel-page">
      <Logo size={72} />
      <XCircle className="mt-8 text-gray-400" size={56} />
      <h1 className="mt-4 text-2xl font-extrabold text-gray-900" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t("cancel.title")}</h1>
      <p className="mt-2 text-sm text-gray-600">{t("cancel.sub")}</p>
      <Link to="/pricing" data-testid="cancel-retry-button" className="mt-6 rounded-full bg-emerald-500 px-6 py-3 text-sm font-bold text-white hover:bg-emerald-600">{t("cancel.retry")}</Link>
    </div>
  );
}
